import React from "react";
import "./FlightSegmentTimeline.css";

export default function FlightSegmentTimeline({ leg }) {
  if (!leg) return null;
  const isDirect = Number(leg.stops) === 0;
  const stopLabel = leg.stopsDetailLabel || leg.stopsLabel;

  return (
    <div className="fe2-dstl">
      <div className="fe2-dstl__endpoints">
        <div className="fe2-dstl__end">
          <time className="fe2-dstl__time fe2-ltr">{leg.depTime}</time>
          <span className="fe2-dstl__iata fe2-ltr">{leg.depIata}</span>
          {leg.depCity ? <span className="fe2-dstl__city">{leg.depCity}</span> : null}
        </div>

        <div className="fe2-dstl__mid">
          <span className="fe2-dstl__duration fe2-ltr">{leg.duration}</span>
          <span className="fe2-dstl__line" aria-hidden />
          <span
            className={
              isDirect
                ? "fe2-dstl__stops fe2-dstl__stops--direct"
                : "fe2-dstl__stops fe2-dstl__stops--connect"
            }
          >
            {stopLabel}
          </span>
        </div>

        <div className="fe2-dstl__end fe2-dstl__end--arr">
          <time className="fe2-dstl__time fe2-ltr">{leg.arrTime}</time>
          <span className="fe2-dstl__iata fe2-ltr">{leg.arrIata}</span>
          {leg.arrCity ? <span className="fe2-dstl__city">{leg.arrCity}</span> : null}
        </div>
      </div>
    </div>
  );
}
